// src/pages/FAQ.jsx
import React from "react";
import BackToHome from "../components/BackToHome";

export default function FAQ() {
  return (
    <main className="container pad">
      <BackToHome />

      <h1>よくある質問（FAQ）</h1>

      <h2>Q. MentalGPT は医療サービスですか？</h2>
      <p>
        いいえ。MentalGPT は AI によるセルフケア支援サービスであり、
        医療行為・診断・治療を行うものではありません。心身の不調が強い場合は、
        医療機関や専門機関へのご相談をおすすめします。
      </p>

      <h2>Q. 無料体験はありますか？</h2>
      <p>
        はい。7日間の無料体験があります。体験期間中に解約いただければ料金は発生しません。
      </p>

      <h2>Q. 支払い方法は？</h2>
      <p>クレジットカード決済（Stripe）に対応しています。</p>

      <h2>Q. 解約はできますか？</h2>
      <p>
        はい。マイページからいつでも解約可能です。次回以降の請求は行われません。
      </p>

      <h2>Q. 相談内容はどれくらい保存されますか？</h2>
      <p>
        プランにより異なります。ライトプランは30日間、スタンダードプランは90日間保存されます。
      </p>

      <h2>Q. CSV出力はできますか？</h2>
      <p>スタンダードプランで対応予定です。</p>

      <h2>Q. メンタル以外の相談もできますか？</h2>
      <p>
        技術的には可能ですが、サービスの主旨としてはメンタルケアに特化しています。
        その点をご理解の上ご利用ください。
      </p>

      <p className="mini-note">
        本FAQに記載の内容は随時更新される場合があります。
      </p>
    </main>
  );
}